// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dfc65e60","453":"67eb599b","732":"2f135565"}[chunkId] + ".chunk.js";
};